import React from "react";
import { GiftIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { bonuses } from "../data/content";
export function Bonuses() {
  return <section className="px-3 py-16 md:px-5 md:py-24" data-id="element-66" data-mp="plsje24mow86">
      <div className="mx-auto max-w-4xl" data-id="element-67" data-mp="aua7afew3lu3">
        <div className="px-2 text-center" data-id="element-68" data-mp="at8tw4aein97">
          <span className="inline-flex items-center gap-2 rounded-full bg-gold px-4 py-1.5 text-sm font-extrabold uppercase text-plum-950" data-id="element-69" data-mp="ft4o5btar0bk">
            <GiftIcon className="h-4 w-4" aria-hidden data-id="element-70" data-mp="1whr791cga5n" /> 5 exclusive bonuses — free
          </span>
          <h2 className="mt-5 font-display text-[30px] font-extrabold leading-tight text-ink md:text-5xl" data-id="element-71" data-mp="5tvwwqptfzsw">
            Today, you'll also receive these <em className="text-plum-600" data-id="element-72" data-mp="3t06getcfk98y">5 professional bonuses</em> free
          </h2>
          <p className="mt-4 text-[17px] text-ink/70" data-id="element-73" data-mp="1mai3lz3qa0xb">
            Total bonus value: <s className="font-bold text-red-600" data-id="element-74" data-mp="1m8fedhaegbtn">$147</s> — included with your $27 purchase.
          </p>
        </div>

        <ul className="mt-10 space-y-6" data-id="element-75" data-mp="3ie6hjg9krzv5">
          {bonuses.map(b => <li key={b.number} className="overflow-hidden rounded-3xl bg-white shadow-[0_2px_24px_-8px_rgba(42,16,69,0.18)]" data-id="element-76" data-mp="3icbxs5a1idsn">
              <img src={b.image} alt={`Bonus ${b.number}: ${b.title}`} className="block w-full bg-white" loading="lazy" data-id="element-77" data-mp="3r6i5mvh7vb7y" />
              <div className="p-5 md:p-8" data-id="element-78" data-mp="3n4wogxxngary">
                <div className="flex flex-wrap items-center justify-between gap-2" data-id="element-79" data-mp="3n79bvqm6fdce">
                  <span className="rounded-md bg-plum-800 px-3 py-1 text-xs font-extrabold uppercase tracking-wider text-white" data-id="element-80" data-mp="2zfu6tq30mhxg">
                    Bonus #{b.number}
                  </span>
                  <span className="text-sm font-semibold text-ink/60" data-id="element-81" data-mp="38htpemtohu2i">
                    Value: <s className="text-red-600" data-id="element-82" data-mp="33g4b8yb5t0a7">${b.value}</s>{" "}
                    <strong className="ml-1 rounded bg-go/10 px-2 py-0.5 font-extrabold text-go-dark" data-id="element-83" data-mp="nprk1895ipl5">FREE</strong>
                  </span>
                </div>
                <h3 className="mt-4 font-display text-2xl font-extrabold leading-tight text-ink md:text-3xl" data-id="element-84" data-mp="iqoqajymg5sh">{b.title}</h3>
                <p className="mt-3 text-[16px] leading-relaxed text-ink/75" data-id="element-85" data-mp="3cl94gpjtv5pv">{b.text}</p>
                {b.tags.length > 0 && <ul className="mt-4 flex flex-wrap gap-2" data-id="element-86" data-mp="3lj33w9cw2fh9">
                    {b.tags.map(t => <li key={t} className="rounded-full bg-plum-50 px-3 py-1 text-sm font-medium text-plum-800" data-id="element-87" data-mp="3qixro41daoy3">
                        {t}
                      </li>)}
                  </ul>}
              </div>
            </li>)}
        </ul>

        <div className="mt-10 px-2" data-id="element-88" data-mp="32sla01gbldub">
          <CtaButton label="Yes! I want the system + 5 bonuses" data-id="element-89" data-mp="32rk0w2iv71f8" />
        </div>
      </div>
    </section>;
}